interface SectionHeadProps {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: 'left' | 'center';
  light?: boolean;
  id?: string;
}

export default function SectionHead({ eyebrow, title, desc, align = 'left', light = false, id }: SectionHeadProps) {
  return (
    <div className={`${align === 'center' ? 'mx-auto text-center' : ''} max-w-2xl`}>
      <span
        className={`inline-flex items-center gap-2 rounded-full px-3 py-1 text-xs font-bold tracking-wide ${
          light ? 'bg-background-50/10 text-accent-400' : 'bg-primary-50 text-primary-700'
        }`}
      >
        <i className="ri-sparkling-2-fill" aria-hidden="true"></i>
        {eyebrow}
      </span>
      <h2
        id={id}
        className={`mt-4 text-2xl font-black leading-tight md:text-4xl ${
          light ? 'text-background-50' : 'text-foreground-950'
        }`}
      >
        {title}
      </h2>
      {desc && (
        <p className={`mt-3 text-sm leading-relaxed md:text-base ${light ? 'text-background-100/80' : 'text-foreground-600'}`}>
          {desc}
        </p>
      )}
    </div>
  );
}